<template>
  <layout-main-inner title="质量管理">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template
        v-if="userPermission.ENT"
        slot="title">
        <create-inspect-btn />
      </template>
      <template slot="form">
        <!-- <el-select
          v-model="config.status"
          @change="handleCurrentChange(1)">
          <el-option
            label="全部"
            :value="null">
          </el-option>
          <el-option
            v-if="userPermission.OPERATE || (userPermission.ENT && aduitFlag)"
            label="待提交"
            :value="1">
          </el-option>
          <el-option
            v-if="(userPermission.SUPERVISE && userDetail.inspectReportAudit === 1) || userPermission.OPERATE || (userPermission.ENT && aduitFlag)"
            label="审核中"
            :value="2">
          </el-option>
          <el-option
            v-if="(userPermission.SUPERVISE && userDetail.inspectReportAudit === 1) || userPermission.OPERATE || (userPermission.ENT && aduitFlag)"
            label="审核通过"
            :value="3">
          </el-option>
          <el-option
            v-if="(userPermission.SUPERVISE && userDetail.inspectReportAudit === 1) || userPermission.OPERATE || (userPermission.ENT && aduitFlag)"
            label="审核不通过"
            :value="4">
          </el-option>
          <el-option
            label="紧急召回"
            :value="9">
          </el-option>
        </el-select> -->
        <!-- <el-radio-group v-model="config.status"
                        @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1"
                           v-if="userPermission.OPERATE || (userPermission.ENT && aduitFlag)">待提交</el-radio-button>
          <el-radio-button :label="2"
                           v-if="userPermission.SUPERVISE || userPermission.OPERATE || (userPermission.ENT && aduitFlag)">审核中</el-radio-button>
          <el-radio-button :label="3"
                           v-if="userPermission.SUPERVISE || userPermission.OPERATE || (userPermission.ENT && aduitFlag)">审核通过</el-radio-button>
          <el-radio-button :label="4"
                           v-if="userPermission.SUPERVISE || userPermission.OPERATE || (userPermission.ENT && aduitFlag)">审核不通过</el-radio-button>
          <el-radio-button :label="9">紧急召回</el-radio-button>
        </el-radio-group> -->
        <!-- <assign-ent-select
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          v-model="config.vendorId"
          style="margin-left: 10px;"
          immediate
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" /> -->
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="编号"
          :resizable="false"
          width="180">
          <template slot-scope="{row}">
            <link-route :link-to="`/inspect-detail?vendorId=${row.vendorId}&inspectReportId=${row.inspectReportId}`">
              {{ row.certNumber || row.declarationCode }}
            </link-route>
          </template>
        </el-table-column>
        <!-- <el-table-column
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          label="企业名称"
          prop="vendorName"></el-table-column> -->
        <el-table-column
          label="商品"
          :resizable="false"
          prop="productNames">
          <template slot-scope="{row}">
            <span
              v-for="(item, index) in row.productNames"
              :key="index">{{ item }} <span v-if="row.productNames.length - 1 !== index">，</span>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="管理/服务机构"
          width="140" :resizable="false"
          prop="regulatorName">
        </el-table-column>
        <el-table-column
          label="贸易类别" :resizable="false"
          width="100">
          <template slot-scope="{row}">
            {{ row.tradeType | tradeType() }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="状态" :resizable="false"
          width="120">
          <template slot-scope="{row}">
            <template v-if="row.needAudit === 1">
              <el-tag v-if="row.status === 1">待提交</el-tag>
              <el-tag
                v-if="row.status === 2"
                type="info">审核中</el-tag>
              <el-tag
                v-if="row.status === 3"
                type="success">审核通过</el-tag>
              <el-tag
                v-if="row.status === 4"
                type="danger">审核不通过</el-tag>
              <el-tag
                v-if="row.status === 9"
                type="danger">紧急召回</el-tag>
            </template>
            <template v-if="row.needAudit === 0">
              <el-tag
                v-if="row.status === 9"
                type="danger">紧急召回</el-tag>
            </template>
          </template>
        </el-table-column> -->
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="检验状态">
          <template slot-scope="{row}">
            {{ row.status | batchStatus()}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          :resizable="false"
          label="操作"
          width="80">
          <template slot-scope="{row}"> -->
        <!-- <div v-if="userPermission.SUPERVISE && row.status=== 2">
              <el-dropdown @command="auditinspectreport">
                <el-button type="text">审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{inspectReportId: row.inspectReportId,vendorId:row.vendorId,regulatorId: row.regulatorId,passed: 1}">通过</el-dropdown-item>
                  <el-dropdown-item :command="{inspectReportId: row.inspectReportId,vendorId:row.vendorId,regulatorId: row.regulatorId,passed: 0}">不通过</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
        <!-- <div v-if="userPermission.ENT"> -->
        <!-- <el-button
                v-if="row.needAudit === 1 && (row.status=== 1 || row.status=== 4)"
                type="text"
                @click="applyauditinspectreport(row)">提交审核</el-button>
              <el-button
                v-if="row.needAudit === 1 && row.status=== 2"
                type="text"
                @click="cancelauditinspectreport(row)">撤销审核</el-button> -->
        <!-- <el-button
                v-if="row.needAudit === 0 || (row.needAudit === 1 && row.status=== 1)"
                type="danger"
                @click="deleteInspect(row)">删除</el-button>
            </div> -->
        <!-- <div v-if="userPermission.OPERATE">
              <el-button
                type="text"
                @click="deleteInspect(row)">删除</el-button>
            </div> -->
        <!-- </template>
        </el-table-column> -->
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
// import AssignEntSelect from '@/components/business/assign-ent-select.vue'
import CreateInspectBtn from './busi/create-inspect-btn.vue'
import { mapState } from 'vuex'
export default {
  name: 'InspectList',
  components: { CreateInspectBtn },
  data() {
    return {
      loading: false,
      aduitFlag: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query,
      userDetail: state => state.account.userDetail
    }),
    status() {
      return this.userDetail.inspectReportAudit === 1 ? [2, 3, 4, 9] : null
    }
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    // if (this.userPermission.ENT) {
    //   this.getvendorregulators(this.userDetail.vendorId)
    // }
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('inspect/getinspectreports', {
        payload: {
          ...this.config,
          status: this.config.status === null ? null : [this.config.status]
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            i.status = i.status === 10 ? 1 : i.status
            i.productNames = i.productNames ? i.productNames.split(',') : []
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    applyauditinspectreport(row) {
      this.$confirm('是否立即提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('inspect/applyauditinspectreport', {
          payload: {
            inspectReportId: row.inspectReportId,
            vendorId: row.vendorId
          },
          success: () => {
            this.fetchList()
            this.loading = false
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    cancelauditinspectreport(row) {
      this.$confirm('是否立即撤销审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('inspect/cancelauditinspectreport', {
          payload: {
            inspectReportId: row.inspectReportId,
            vendorId: row.vendorId
          },
          success: () => {
            this.fetchList()
            this.loading = false
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCommand(v) {
      console.log(v)
    },
    auditinspectreport(row) {
      if (row.passed === 0) {
        this.$prompt('请输入说明', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          this.loading = true
          this.$store.dispatch('inspect/auditinspectreport', {
            payload: {
              ...row,
              memo: value
            },
            success: () => {
              this.fetchList()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      } else {
        this.$confirm('是否通过审核?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$store.dispatch('inspect/auditinspectreport', {
            payload: row,
            success: () => {
              this.fetchList()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      }
    },
    deleteInspect(row) {
      this.$confirm('此操作将永久删除该检验单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('inspect/deleteinspectreport', {
            payload: {
              inspectReportId: row.inspectReportId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    getvendorregulators(vendorId) {
      this.$store.dispatch('vendor/getvendorregulators', {
        payload: { vendorId },
        success: (res) => {
          this.aduitFlag = res.data.regulators.filter(i => i.inspectReportAudit === 1).length > 0
        },
        fail: () => {
          this.regulators = []
        }
      })
    }
  }
}
</script>
